<script lang="ts">
import { AppDropdownComponent } from "./app-dropdown";

export default AppDropdownComponent;
</script>
<template>
    <div
        class="app-dropdown"
        :class="{ 'app-dropdown-theme-default': defaultTheme }"
        v-bind="$attrs"
        v-click-outside="() => (isOpen = false)"
    >
        <app-block-ui :blocked="blocked">
            <vue-tippy
                v-bind="tippyProps"
                v-app-tippy-visible="isOpen"
                interactive
                :placement="placement"
                :theme="tippyTheme"
                :offset="[0, 0]"
                :animation="animation"
                :arrow="arrow"
                trigger="manual"
                :hide-on-click="false"
                max-width="none"
                tag="div"
                class="app-dropdown-selected"
                :class="{ 'selected-box-mode': showSelectedAsBox }"
                content-tag="ul"
                content-class="app-dropdown-items"
                @click="disabled ? null : isOpen = !isOpen"
                @keydown.prevent.down="getNextOrPrev('next')"
                @keydown.prevent.up="getNextOrPrev('prev')"
                :sticky="true"
            >
                <slot name="selected" v-bind="slotSelectedProps">
                    <app-dropdown-selected
                        :fontSize="fontSize"
                        :tabindex="tabindex"
                        v-bind="slotSelectedProps"
                        @keyup.enter="isOpen = !isOpen"
                        @keyup.space="isOpen = !isOpen"
                    ></app-dropdown-selected>
                </slot>
                <template #content>
                    <slot name="search" v-if="searchable" v-bind="slotSearchProps">
                        <app-dropdown-search
                            v-bind="slotSearchProps"
                        ></app-dropdown-search>
                    </slot>
                    <div :class="{ 'searchable-scroll-panel': searchable }">
                        <slot name="dropdown-items">
                            <slot
                                name="no-results"
                                v-if="searchable && !finalViewOptions.length"
                            >
                                <div class="app-dropdown-no-results">
                                    <slot name="no-results-text">
                                        <i18n-t keypath="dropdown.noResults" />
                                    </slot>
                                </div>
                            </slot>
                            <slot v-if="firstOption?.show" name="option">
                                <div class="app-dropdown-option-link">
                                    <router-link :to="firstOption?.url">
                                        <svg class="sprite-icon" width="12" height="12">
                                            <use xlink:href="/img/sprite.svg#plus"></use>
                                        </svg>
                                        {{ firstOption?.title }}
                                    </router-link>
                                </div>
                            </slot>
                            <template
                                v-for="(data, index) of finalViewOptions"
                                :key="trackBy(data.details.option, index)"
                            >
                                <slot
                                    name="option"
                                    v-bind="slotOptionProps(data.value, data.details)"
                                >
                                    <app-dropdown-option
                                        :fontSize="fontSize"
                                        v-bind="slotOptionProps(data.value, data.details)"
                                    ></app-dropdown-option>
                                </slot>
                            </template>
                        </slot>
                    </div>
                </template>
            </vue-tippy>
        </app-block-ui>
    </div>
</template>

<style lang="scss">
@import "../../../shared/styles/mixins.scss";

.searchable-scroll-panel {
    max-height: c-rem(290);
    overflow: auto;
    &::-webkit-scrollbar {
        width: c-rem(3);
        height: c-rem(8);
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(24, 29, 39, 0.5);
    }
}
</style>
